import React, { useState, useEffect } from 'react';
import Layout from '../shared/Layout';

// Importa tus páginas
import DocenteAsistencia from './DocenteAsistencia';
import DocenteAsistenciaPreadmision from './DocenteAsistenciaPreadmision';
import DocenteHistorialPreadmision from './DocenteHistorialPreadmision';
import DocenteMatriculacionProceso from './DocenteMatriculacionProceso';
import DocenteMatriculacionPeriodo from './DocenteMatriculacionPeriodo';
import DocenteMatriculacionConsolidado from './DocenteMatriculacionConsolidado';
import DocenteLicencias from './DocenteLicencias';
import DocentePrestamos from './DocentePrestamos';
import HistorialAcademico from './HistorialAcademico';
import ExamenesDocente from './ExamenesDocente';
import DocenteHorario from './DocenteHorario';
import DocenteTareas from './DocenteTareas';
import DocenteDocumentacion from './DocenteDocumentacion';
import DocenteAsignaturas from './DocenteAsignaturas';

const DashboardDocente = ({ onLogout, userName = 'Usuario', menuItems: externalMenuItems, sourceUrl }) => {
  const [menuItems, setMenuItems] = useState([]);
  const [activeMenu, setActiveMenu] = useState(null);

  // Cargar menús desde la BD o props
  useEffect(() => {
    console.log("DashboardDocente: Menús recibidos desde:", sourceUrl || "Desconocido");
    console.log("externalMenuItems raw:", externalMenuItems);

    if (Array.isArray(externalMenuItems) && externalMenuItems.length > 0) {
      // Normalizamos preservando id_padre, id_menu y orden para menús jerárquicos
      const normalized = externalMenuItems.map(m => ({
        id: m.id,
        id_menu: m.id_menu,
        label: m.label,
        id_padre: m.id_padre,
        orden: m.orden || 0
      }));

      console.log("normalized menuItems:", normalized);

      setMenuItems(normalized);
      // Seleccionar el primer menú que no tenga hijos como activo
      const firstLeaf = normalized.find(m => !normalized.some(n => n.id_padre === m.id_menu));
      setActiveMenu(firstLeaf?.id || normalized[0].id);
    }
  }, [externalMenuItems, sourceUrl]);

  // Renderizar contenido según el menú activo
  const renderContent = () => {
    switch (activeMenu) {
      case 'docente_asignaturas':
        return <DocenteAsignaturas />;
      case 'docente_documentacion':
        return <DocenteDocumentacion />;
      // Asistencia con submenús
      case 'docente_asistencia':
        return <DocenteAsistencia />;
      case 'docente_asistencia_preadmision':
        return <DocenteAsistenciaPreadmision />;
      case 'docente_asistencia_matriculacion':
        return <DocenteAsistencia />;
      // Historial Académico con submenús
      case 'docente_evaluaciones':
        return <HistorialAcademico />;
      case 'docente_historial_preadmision':
        return <DocenteHistorialPreadmision />;
      case 'docente_historial_matriculacion':
        return <HistorialAcademico />;
      // Matriculación nivel 3 (Proceso, Periodo, Consolidado)
      case 'docente_matriculacion_proceso':
        return <DocenteMatriculacionProceso />;
      case 'docente_matriculacion_periodo':
        return <DocenteMatriculacionPeriodo />;
      case 'docente_matriculacion_consolidado':
        return <DocenteMatriculacionConsolidado />;
      case 'docente_examenes':
        return <DocenteTareas />;
      case 'docente_horario':
        return <DocenteHorario />;
      case 'docente_tareas':
        return <DocenteTareas />;
      case 'docente_licencias':
        return <DocenteLicencias />;
      case 'docente_prestamos':
        return <DocentePrestamos />;
      default:
        return (
          <div className="p-8">
            <div className="bg-white rounded-lg shadow-sm p-6 text-gray-600">
              Sección no encontrada o no implementada. (Menu ID: {activeMenu})
            </div>
          </div>
        );
    }
  };

  return (
    <Layout
      userRole="Docente"
      userName={userName}
      onLogout={onLogout}
      menuItems={menuItems}      // Pasamos los menús ya normalizados
      activeMenu={activeMenu}
      setActiveMenu={setActiveMenu}
    >
      {renderContent()}
    </Layout>
  );
};

export default DashboardDocente;
